module.exports = __webpack_public_path__ + "static/img/home-main@3x.23eeafe4.png";